export function isDev() {
    return ['dev', 'development', 'weworkappDev', 'customDev', 'slideCustomDev', 'test'].includes(import.meta.env.MODE)
}

export function isLocal() {
    return import.meta.env.MODE === 'dev'
}

export function isPro() {
    return ['production', 'weworkapp', 'proAll'].includes(import.meta.env.MODE)
}

export default function env() {
    // 本地环境
    if (isLocal()) {
        return 'local'
    }
    // 开发环境
    if (isDev()) {
        return 'development'
    }
    // 线上环境
    return 'production'
}

export function getUrlMap() {
    const domain = location.host.split('.')?.slice(-2).join('.')
    if (isDev()) {
        return {
            mUrl: import.meta.env.VITE_MSCRMURL,
            originUrl: import.meta.env.VITE_ORIGIN_URL,
            mpUrl: import.meta.env.VITE_MP_URL,
            tuxiuUrl: import.meta.env.VITE_TUXIU_URL
        }
    }
    else {
        return {
            mUrl: `${location.protocol}//m.${domain}`,
            originUrl: location.origin,
            mpUrl: `${location.protocol}//mp.${domain}`,
            tuxiuUrl: `tuxiu.${domain}`
        }
    }
}
